import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { onBeforeMount, onBeforeUnmount, onMounted, nextTick, ref, watch, shallowRef, toRefs, computed } from "vue";
import { getIcon } from "@/helpers/api";
import { useDeviceStatus } from "@/stores/deviceStatus";
import CustomZoomer from "@/globals/modules/CustomZoomer/CustomZoomer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageViewer',
  props: {
  source: { type: String, required: true },
  zoomable: { type: Boolean, default: true },
  rotation: { type: Number, default: 0 },
},
  emits: ["click", "loaded"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const vZoomerRef = shallowRef<InstanceType<typeof CustomZoomer> | null>(null);
watch(
  computed(() => props.rotation),
  () => vZoomerRef.value?.reset()
);

const emit = __emit;

const isZoomed = ref<boolean>(false);
const { isWeb } = toRefs(useDeviceStatus());
const expand = ref<string>();

onBeforeMount(async () => {
  expand.value = await getIcon("1602", "expand");
});

const handleClick = (event: Event) => {
  if (props.zoomable) {
    event.stopPropagation();
  }
  emit("click", props.source);
};


const cmpHeight = ref<string>("100%");
const imgContainerRef = shallowRef<HTMLElement | null>(null);
let containerResizeObserver: ResizeObserver | null = null;

const updateHeight = () => {
  if (imgContainerRef.value !== null) {
    const h = window.getComputedStyle(imgContainerRef.value).getPropertyValue("height");
    if (h && h !== "0px" && h !== "auto") cmpHeight.value = h;
  }
};

function loaded() {
  emit("loaded");
  updateHeight();
  vZoomerRef.value?.reset();
}

onMounted(async () => {
  await nextTick();
  updateHeight();

  if (typeof ResizeObserver !== "undefined" && imgContainerRef.value) {
    containerResizeObserver = new ResizeObserver(() => updateHeight());
    containerResizeObserver.observe(imgContainerRef.value);
  }
});

onBeforeUnmount(() => {
  containerResizeObserver?.disconnect();
  containerResizeObserver = null;
});

/**
 * ---- NOVO: estado e métodos de FIT ----
 */
const fitMode = ref<"height" | "width" | null>(null);

const fitModeClass = computed(() => {
  if (fitMode.value === "height") return "fit-height";
  if (fitMode.value === "width") return "fit-width";
  return "";
});

// chamado quando clicas no botão "zoom to height"
const fitToHeight = () => {
  fitMode.value = "height";
  isZoomed.value = false;
  vZoomerRef.value?.reset();
};

// chamado quando clicas no botão "zoom to width"
const fitToWidth = () => {
  fitMode.value = "width";
  isZoomed.value = false;
  vZoomerRef.value?.reset();
};

// expor estes métodos para o componente pai poder chamar
__expose({
  fitToHeight,
  fitToWidth,
});

const getRotationCss = computed(() => {
  return {
    transform: `rotate(${props.rotation}deg)`,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = (e) => (!_unref(isWeb) ? handleClick(e) : null)),
    class: "image-viewer",
    ref_key: "imgContainerRef",
    ref: imgContainerRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.zoomable && cmpHeight.value)
        ? (_openBlock(), _createBlock(CustomZoomer, {
            key: 0,
            limitTranslation: false,
            zoomed: isZoomed.value,
            "onUpdate:zoomed": _cache[0] || (_cache[0] = (v) => (isZoomed.value = v)),
            ref_key: "vZoomerRef",
            ref: vZoomerRef,
            rotation: __props.rotation
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: __props.source,
                  alt: "",
                  srcset: "",
                  class: _normalizeClass(["img", fitModeClass.value]),
                  onLoad: loaded
                }, null, 42, _hoisted_3)
              ])
            ]),
            _: 1
          }, 8, ["zoomed", "rotation"]))
        : _createCommentVNode("", true),
      (!__props.zoomable || !cmpHeight.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: __props.source,
            alt: "",
            srcset: "",
            class: _normalizeClass(["img", fitModeClass.value]),
            onLoad: loaded,
            style: _normalizeStyle(getRotationCss.value)
          }, null, 46, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})